import React from "react";

interface EDSSpinnerProps {
  size?: "small" | "medium" | "large";
  className?: string;
}

const sizeClasses: Record<EDSSpinnerProps["size"] & string, string> = {
  small: "w-4 h-4",
  medium: "w-6 h-6",
  large: "w-8 h-8"
};

export const EDSSpinner: React.FC<EDSSpinnerProps> = ({
  size = "medium",
  className = ""
}) => {
  return (
    <div
      className={[
        "eds-spinner",
        `eds-spinner--${size}`,
        "inline-flex items-center justify-center pt-4",
        className
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div
        className={[
          "eds-spinner__circle",
          sizeClasses[size],
          "rounded-full border-2 border-solid border-transparent animate-spin"
        ].join(" ")}
        style={{
          borderTopColor: "var(--primaryColor, var(--accent-color, #1fd4d4))"
        }}
      />
    </div>
  );
};
